import React from "react";
import "./Avatar.css";

/**
 * Avatar de usuario: la inicial del nombre en un círculo.
 *
 * Antes había dos placeholders distintos, un dibujo genérico de una persona y
 * una imagen traída de ui-avatars.com, que es un servicio externo al que se le
 * mandaba el nombre del usuario en la URL. Esto se dibuja en el navegador: sin
 * peticiones de red y sin sacar datos de nadie.
 *
 * Si el usuario subió foto, manda la foto; si falla al cargar, cae a la inicial.
 */

const iniciales = (nombre = "") => {
  const partes = String(nombre).trim().split(/\s+/).filter(Boolean);

  if (partes.length === 0) return "?";
  if (partes.length === 1) return partes[0][0].toUpperCase();

  return (partes[0][0] + partes[1][0]).toUpperCase();
};

export default function Avatar({ nombre, src, tamano = 40, className = "" }) {
  const [falloLaFoto, setFalloLaFoto] = React.useState(false);
  const estilo = { width: tamano, height: tamano, fontSize: tamano * 0.42 };

  if (src && !falloLaFoto) {
    return (
      <img
        className={`avatar avatar-foto ${className}`.trim()}
        style={estilo}
        src={src}
        alt={nombre}
        onError={() => setFalloLaFoto(true)}
      />
    );
  }

  return (
    <span
      className={`avatar avatar-inicial ${className}`.trim()}
      style={estilo}
      aria-hidden="true"
      title={nombre}
    >
      {iniciales(nombre)}
    </span>
  );
}
